// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"adaa6f8a","330":"adaa6f8a","771":"adaa6f8a","790":"adaa6f8a","815":"adaa6f8a","841":"c87fe4de"}[chunkId] + ".chunk.css";
};